import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";

const OldPrintExamDataSheetMultiple = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    document.title = "Old Exam Data Sheet (Multiple)";
    setLoading(true);
    setErrorMessage("");

    const urlParams = new URLSearchParams(window.location.search);
    const FirstExamID = urlParams.get("FirstExamID");
    const SecondExamID = urlParams.get("SecondExamID");
    const ThirdExamID = urlParams.get("ThirdExamID");
    const FourthExamID = urlParams.get("FourthExamID");
    const Wing_Id = urlParams.get("WingId");
    const Class_Id = urlParams.get("ClassId");
    const Section_Id = urlParams.get("SectionId");
    const PrintTotal = urlParams.get("PrintTotal");
    const Group = urlParams.get("Group");

    const data = {
      AccessKey,
      UserID,
      MemberType,
      FirstExamID,
      SecondExamID,
      ThirdExamID,
      FourthExamID,
      Wing_Id,
      Class_Id,
      Section_Id,
      PrintTotal,
      Group,
    };

    axios({
      method: "post",
      url: config.base_url + "Exam/GetOldExamDataSheetMultiple",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        const payload = response?.data;
        if (payload?.status_code === 1) {
          setLedger(payload?.ListofSections || []);
        } else {
          setErrorMessage(payload?.status_message || "Unable to load data.");
        }
        setLoading(false);
      })
      .catch(() => {
        setErrorMessage("Network error. Please try again.");
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType]);

  return (
    <>
      <Page orientation="landscape" size="a4">
        <table className="table table-sm table-bordered table-print" style={{ border: "transparent" }}>
          <thead>
            <tr>
              <th>
                <PrintHeader title="" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div>
                  {loading ? (
                    <Spinner animation="border" role="status"></Spinner>
                  ) : errorMessage ? (
                    <div className="alert alert-warning mb-0" role="alert">
                      {errorMessage}
                    </div>
                  ) : (
                    <>
                      {listOfLedger &&
                        listOfLedger.map((item, index) => (
                          <div key={index} style={{ pageBreakAfter: index !== listOfLedger.length - 1 ? "always" : "auto" }}>
                            <div>
                              <div className="row">
                                <div className="col-md-4">
                                  <h6 style={{ fontSize: "12x" }}>
                                    Master Sheet for: {item.Wing_Name}-{item.Class_Name}-{item.Section_Name}
                                  </h6>
                                </div>
                                <div className="col-md-4 text-center">
                                  <h6 style={{ fontSize: "12px" }}>Exam: {item.Exam_Name} Total Marks: {item.Total_Marks}</h6>
                                </div>
                                <div className="col-md-4 text-end">
                                  <h6 style={{ fontSize: "12px" }}>{item.Section_Teacher_Name}</h6>
                                </div>
                              </div>

                              <table className="table table-sm table-bordered table-print">
                                <thead>
                                  <tr>
                                    <th style={{ width: "50px", textAlign: "center", verticalAlign: "top" }}>SR #</th>
                                    <th style={{ width: "90px", verticalAlign: "top" }}>Code #</th>
                                    <th style={{ width: "190px", verticalAlign: "top" }}>Student Name</th>
                                    {(item.ListofSubjects1 || []).map((itemSubjects, subjectIndex) => (
                                      <th key={`s1-${subjectIndex}`} style={{ textAlign: "center", verticalAlign: "top" }}>
                                        {itemSubjects.Name.substring(0, 2)}
                                        <br /> {itemSubjects.Total_Marks}
                                      </th>
                                    ))}
                                    {(item.ListofSubjects2 || []).map((itemSubjects, subjectIndex) => (
                                      <th key={`s2-${subjectIndex}`} style={{ textAlign: "center", verticalAlign: "top" }}>
                                        {itemSubjects.Name.substring(0, 2)}
                                        <br /> {itemSubjects.Total_Marks}
                                      </th>
                                    ))}
                                    {(item.ListofSubjects3 || []).map((itemSubjects, subjectIndex) => (
                                      <th key={`s3-${subjectIndex}`} style={{ textAlign: "center", verticalAlign: "top" }}>
                                        {itemSubjects.Name.substring(0, 2)}
                                        <br /> {itemSubjects.Total_Marks}
                                      </th>
                                    ))}
                                    <th>Total Marks</th>
                                    <th>Position</th>
                                    <th>%Age</th>
                                    <th>Grade</th>
                                    <th>Remarks</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(item.StudentsInSection || []).map((itemStudent, studentIndex) => (
                                    <tr key={`student-${studentIndex}`}>
                                      <td className="text-center">{itemStudent.Serial_No}</td>
                                      <td>{itemStudent.Registration_No}</td>
                                      <td>{itemStudent.Student_Name}</td>
                                      {(itemStudent.ListofSubjectsInner1 || []).map((itemMarks, markIndex) => (
                                        <td key={`m1-${markIndex}`} style={{ width: "40px" }}>
                                          {itemMarks.Obtained_Marks}
                                        </td>
                                      ))}
                                      {(itemStudent.ListofSubjectsInner2 || []).map((itemMarks, markIndex) => (
                                        <td key={`m2-${markIndex}`} style={{ width: "40px" }}>
                                          {itemMarks.Obtained_Marks}
                                        </td>
                                      ))}
                                      {(itemStudent.ListofSubjectsInner3 || []).map((itemMarks, markIndex) => (
                                        <td key={`m3-${markIndex}`} style={{ width: "40px" }}>
                                          {itemMarks.Obtained_Marks}
                                        </td>
                                      ))}
                                      <td>{itemStudent.FirstTermObtained_Marks}</td>
                                      <td>{itemStudent.FirstTermClass_Position}</td>
                                      <td>{itemStudent.FirstTermPercentMarks}</td>
                                      <td>{itemStudent.FirstTermGrade}</td>
                                      <td></td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ))}
                    </>
                  )}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </Page>
    </>
  );
};

export default OldPrintExamDataSheetMultiple;
